// extracted by mini-css-extract-plugin
export default {"container":"SharingPopout_container__gzwyU","header":"SharingPopout_header__S2J9x","textContainer":"SharingPopout_textContainer__Tw7Bg","text":"SharingPopout_text__k0zeh"};